import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { EditAppointmentService } from './../business-services/edit-appointment.service';
import { EditAppointmentComponent } from './../views/appointment/edit-appointment/edit-appointment.component';
import { AppointmentService } from '../business-services/appointment.service';
import { CookieService } from 'ngx-cookie-service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { AppointmentWorkOrderService } from '../business-services/appointment-work-order.service';
import { BehaviorSubject } from 'rxjs';
import { AppointmentGenericTabs } from 'projects/Autofacets-Core/src/app/utils/constant';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { AppointmentCommonService } from '../business-services/appointment-common.service';

@Injectable({
    providedIn: 'root'
})
export class MultiStackPopupService {
    //#region Declaration
    private appointmentStack: any[] = [];
    private languageCode: string = "";
    private features: any[] = [];
    public onCloseTrigger: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    //#endregion

    //#region  Constructor
    constructor(
        private readonly modalService: NgbModal,
        private readonly appointmentService: AppointmentService,
        private readonly editAppointmentService: EditAppointmentService,
        private readonly workOrderService: AppointmentWorkOrderService,
        private readonly cookieservice: CookieService,
        private readonly toastr: ToastrService,
        private readonly spinner: NgxSpinnerService,
        private readonly translate: TranslateService,
        private readonly currentLanguage: CurrentLanguage,
        private readonly secureStorage: SecureStorage,
        private readonly globalSetting: GlobalSetting,
        private readonly commonService: AppointmentCommonService) {
        this.languageCode = this.cookieservice.get('userSelectedLanguage');
        this.currentLanguage.featureList.subscribe((res)=>{
            this.features = res;
        })
    }
    //#endregion

    //#region Appointment Stack
    async OpenAppointment(appointmentId: any, isOpenWhatsAppTab: boolean = false, isOpenFromPlanning = false, extraAppointmentId = 0,isOpenFromWARScreen = false) {
        this.spinner.show();
        this.languageCode = this.cookieservice.get('userSelectedLanguage');
        await this.GetAllAppointmentStatusList().then((_st) => {
            this.appointmentService.GetAppointmentDetail(appointmentId, this.languageCode).then(res => {
                if (res.responseCode === Enums.ErrorCodes.SuccessCode
                    &&  !(res.responseObject?.errorCount > 0)) {
                        const dataMapper = this.AppointmentDataMapper(res.responseObject, isOpenFromWARScreen);
                    this.AddAppointmentStack();
                    this.SetAppointmentStack(dataMapper, {});
                    this.globalSetting.InitEditByOtherConfig(dataMapper.appointmentDetails);
                    this.ApplyEditPopupClass(true);

                    const modalref = this.modalService.open(EditAppointmentComponent, { size: 'lg', windowClass: 'EditPopup appWid' });
                    if(isOpenFromWARScreen){
                        modalref.componentInstance.isViewAppointmentFromWAR = true;
                    }
                    modalref.componentInstance.isOpenWhatsAppTab = isOpenWhatsAppTab;
                    modalref.componentInstance.isOpenFromPlanning = isOpenFromPlanning;
                    modalref.result.then(
                        () => this.OnAppointmentPopupClose(extraAppointmentId)
                    );
                } else {
                    let errorMsg = this.translate.instant("lblAppointmentDetailNotFound");
                    this.toastr.error(errorMsg);
                }
            }).finally(() => {
                this.spinner.hide();
            });
        });
    }
    private OnAppointmentPopupClose(extraAppointmentId = 0) {
        this.globalSetting.RemoveEditByOtherConfig(this.editAppointmentService.appointmentDetails);
        this.editAppointmentService.appointmentDetails = null;
        if (this.appointmentStack.length == 0) {
            this.ApplyEditPopupClass(false);
            if(!this.commonService.isPopupClose){
                this.SetAppointmentStack({ appointmentDetails: null, isEdit: false }, {});
            }
            if (this.appointmentService.isRefreshListing) {
                this.onCloseTrigger.next(true);
                this.appointmentService.isRefreshListing = false;
            }
            else{
                this.onCloseTrigger.next(false);
            }
        }
        else if (this.appointmentStack.length > 0) {
            const stack = this.appointmentStack[this.appointmentStack.length - 1]
            this.SetAppointmentStack(stack.editAppointment, stack.wordOrder);
            this.appointmentStack.pop();
        }
        this.commonService.isPopupClose = false;
        if (extraAppointmentId > 0) {
            this.OpenAppointment(extraAppointmentId);
        }
    }
    private AddAppointmentStack() {
        if (this.editAppointmentService?.appointmentDetails?.id > 0) {
            const isLockFeatureEnabled = this.features.find(x => x.featureCode === Enums.FeatureCode.AppointmentLock)?.isActive ?? false;
            this.appointmentStack.push({
                editAppointment: {
                    appointmentDetails: this.editAppointmentService.appointmentDetails,
                    isEdit: this.editAppointmentService.isEdit,
                    isFromHistoricalWOTab: this.editAppointmentService.isFromHistoricalWOTab,
                    isFromVehicleHistoricalTab: this.editAppointmentService.isFromVehicleHistoricalTab,
                    brandCode: this.editAppointmentService.brandCode,
                    appointmentGuidOfSelectedWO: this.editAppointmentService.appointmentGuidOfSelectedWO,
                    appointmentIdOfSelectedWO: this.editAppointmentService.appointmentIdOfSelectedWO,
                    checkInURL: this.editAppointmentService.checkInURL,
                    trackerURL: this.editAppointmentService.trackerURL,
                    isSSMEnabled: this.editAppointmentService.isSSMEnabled,
                    isRomnasEnabled: this.editAppointmentService.isRomnasEnabled,
                    exportedJson: this.editAppointmentService.exportedJson,
                    isExported: this.editAppointmentService.isExported,
                    isTecRMIEnabled: this.editAppointmentService.isTecRMIEnabled,
                    selectedMainTabNumber: this.editAppointmentService.selectedMainTabNumber,
                    selectedChildTabNumber: this.editAppointmentService.selectedChildTabNumber,
                    isOpenByOtherUser: this.editAppointmentService.isOpenByOtherUser,
                    isLockFeatureEnabled: isLockFeatureEnabled,
                    DemandWiseDocumentCountList: this.editAppointmentService.DemandWiseDocumentCountList,
                    isPlanningDone: this.editAppointmentService.isPlanningDone,
                    AppointmentGenericTabs : this.editAppointmentService.AppointmentGenericTabs,
                    isFromMpo: this.editAppointmentService.isFromMpo
                },
                wordOrder: {
                    appointmentDemandList: this.workOrderService.appointmentDemandList,
                    appointmentJobList: this.workOrderService.appointmentJobList,
                    appointmentJobDetailList: this.workOrderService.appointmentJobDetailList,
                    appointmentPriceDetails: this.workOrderService.appointmentPriceDetails,
                    additionalDemandList: this.workOrderService.additionalDemandList,
                    additionalJobList: this.workOrderService.additionalJobList,
                    additionalJobDetailsList: this.workOrderService.additionalJobDetailsList,
                    taxDetail: this.workOrderService.taxDetail,
                    contactDetails: this.workOrderService.contactDetails,
                    totalPriceToDisplay: this.workOrderService.totalPriceToDisplay,
                    totalPrice: this.workOrderService.totalPrice,
                    totalTime: this.workOrderService.totalTime,
                    rentalCompanyMakeName: this.workOrderService.rentalCompanyMakeName,
                    priceForDisply: this.workOrderService.priceForDisply,
                    totalInvoicePrice: this.workOrderService.totalInvoicePrice,
                    appointmentJobDetailToUpdate: this.workOrderService.appointmentJobDetailToUpdate,
                    qtyCheck: this.workOrderService.qtyCheck,
                    demandQtyCheckflag: this.workOrderService.demandQtyCheckflag,
                    isUpdateAppointment: this.workOrderService.isUpdateAppointment,
                    isDiscountError: this.workOrderService.isDiscountError,
                    partList: this.workOrderService.partList,
                    personnelTax: this.workOrderService.personnelTax,
                    materialTax: this.workOrderService.materialTax,
                    totalPriceInclVAT: this.workOrderService.totalPriceInclVAT,
                    overAllAmountInclTAX: this.workOrderService.overAllAmountInclTAX,
                    isRentalCarUpdated: this.workOrderService.isRentalCarUpdated,
                    selectedRentalCarDetail: this.workOrderService.selectedRentalCarDetail,
                    isDisableSaveButton: this.workOrderService.isDisableSaveButton,
                    features: this.workOrderService.features,
                    BookingDatetime: this.workOrderService.BookingDatetime,
                    isJobDetailDiscountError: this.workOrderService.isJobDetailDiscountError,
                    isAdditionalJobDetailDiscountError: this.workOrderService.isAdditionalJobDetailDiscountError,
                    isWarrantyDocumentSigned: this.workOrderService.isWarrantyDocumentSigned
                }
            });
        }
    }
    private SetAppointmentStack(aStack: any, wStack: any) {
        const isLockFeatureEnabled = this.features.find(x => x.featureCode === Enums.FeatureCode.AppointmentLock)?.isActive ?? false;

        this.editAppointmentService.appointmentDetails = aStack.appointmentDetails;
        this.editAppointmentService.isEdit = aStack.isEdit;
        this.editAppointmentService.isFromHistoricalWOTab = aStack?.isFromHistoricalWOTab ?? false;
        this.editAppointmentService.isFromVehicleHistoricalTab = aStack?.isFromVehicleHistoricalTab ?? false;
        this.editAppointmentService.brandCode = aStack?.brandCode ?? "";
        this.editAppointmentService.appointmentGuidOfSelectedWO = aStack?.appointmentGuidOfSelectedWO ?? null;
        this.editAppointmentService.appointmentIdOfSelectedWO = aStack?.appointmentIdOfSelectedWO ?? null;
        this.editAppointmentService.checkInURL = aStack?.checkInURL ?? null;
        this.editAppointmentService.trackerURL = aStack?.trackerURL ?? null;
        this.editAppointmentService.isSSMEnabled = aStack?.isSSMEnabled ?? false;
        this.editAppointmentService.isRomnasEnabled = aStack?.isRomnasEnabled ?? false;
        this.editAppointmentService.exportedJson = aStack?.exportedJson ?? "";
        this.editAppointmentService.isExported = aStack?.isExported ?? false;
        this.editAppointmentService.isTecRMIEnabled = aStack?.isTecRMIEnabled ?? false;
        this.editAppointmentService.selectedMainTabNumber = aStack?.selectedMainTabNumber ?? 1;
        this.editAppointmentService.selectedChildTabNumber = aStack?.selectedChildTabNumber ?? 1;
        this.editAppointmentService.isOpenByOtherUser = aStack?.isOpenByOtherUser ?? false;
        this.editAppointmentService.isLockFeatureEnabled = isLockFeatureEnabled;
        this.editAppointmentService.DemandWiseDocumentCountList = aStack?.DemandWiseDocumentCountList ?? [];
        this.editAppointmentService.isPlanningDone = aStack?.isPlanningDone ?? false;
        this.editAppointmentService.AppointmentGenericTabs = aStack?.AppointmentGenericTabs ?? AppointmentGenericTabs;
        this.editAppointmentService.isDelete = aStack.isDelete;
        this.editAppointmentService.isFromMpo = aStack?.isFromMpo ?? false;
        if(this.commonService?.contactDetails){
            this.commonService.contactDetails.plannedMechanics = aStack?.appointmentDetails?.plannedMechanics ?? "";
            this.commonService.contactDetails.pastPlannedMechanics = aStack?.appointmentDetails?.pastPlannedMechanics ?? "";
        }

        
        this.workOrderService.appointmentDemandList = wStack?.appointmentDemandList ?? [];
        this.workOrderService.appointmentJobList = wStack?.appointmentJobList ?? [];
        this.workOrderService.appointmentJobDetailList = wStack?.appointmentJobDetailList ?? [];
        this.workOrderService.appointmentPriceDetails = wStack?.appointmentPriceDetails ?? [];
        this.workOrderService.additionalDemandList = wStack?.additionalDemandList ?? [];
        this.workOrderService.additionalJobList = wStack?.additionalJobList ?? [];
        this.workOrderService.additionalJobDetailsList = wStack?.additionalJobDetailsList ?? [];
        this.workOrderService.taxDetail = wStack?.taxDetail ?? null;
        this.workOrderService.contactDetails = wStack?.contactDetails ?? null;
        this.workOrderService.totalPriceToDisplay = wStack?.totalPriceToDisplay ?? 0;
        this.workOrderService.totalPrice = wStack?.totalPrice ?? 0;
        this.workOrderService.totalTime = wStack?.totalTime ?? 0;
        this.workOrderService.rentalCompanyMakeName = wStack?.rentalCompanyMakeName ?? '';
        this.workOrderService.priceForDisply = wStack?.priceForDisply ?? '';
        this.workOrderService.totalInvoicePrice = wStack?.totalInvoicePrice ?? 0;
        this.workOrderService.appointmentJobDetailToUpdate = wStack?.appointmentJobDetailToUpdate ?? [];
        this.workOrderService.qtyCheck = wStack?.qtyCheck ?? false;
        this.workOrderService.demandQtyCheckflag = wStack?.demandQtyCheckflag ?? true;
        this.workOrderService.isUpdateAppointment = wStack?.isUpdateAppointment ?? false;
        this.workOrderService.isDiscountError = wStack?.isDiscountError ?? false;
        this.workOrderService.partList = wStack?.partList ?? [];
        this.workOrderService.personnelTax = wStack?.personnelTax ?? 0;
        this.workOrderService.materialTax = wStack?.materialTax ?? 0;
        this.workOrderService.totalPriceInclVAT = wStack?.totalPriceInclVAT ?? 0;
        this.workOrderService.overAllAmountInclTAX = wStack?.overAllAmountInclTAX ?? 0;
        this.workOrderService.isRentalCarUpdated = wStack?.isRentalCarUpdated ?? false;
        this.workOrderService.selectedRentalCarDetail = wStack?.selectedRentalCarDetail ?? null;
        this.workOrderService.isDisableSaveButton = wStack?.isDisableSaveButton ?? false;
        this.workOrderService.features = wStack?.features ?? [];
        this.workOrderService.BookingDatetime = wStack?.BookingDatetime ?? null;
        this.workOrderService.isJobDetailDiscountError = wStack?.isJobDetailDiscountError ?? false;
        this.workOrderService.isAdditionalJobDetailDiscountError = wStack?.isAdditionalJobDetailDiscountError ?? false;
        this.workOrderService.isWarrantyDocumentSigned = wStack?.isWarrantyDocumentSigned ?? false;
    }
    private AppointmentDataMapper(appointment: any, isCommingFromWar:boolean = false) {
        let mapData = { appointmentDetails: null, isEdit: false, isDelete: false };
        mapData.appointmentDetails = appointment;
        mapData.appointmentDetails.id = appointment.appointmentId;
        mapData.appointmentDetails.workOrderStatus = appointment.workorderStatus;
        mapData.appointmentDetails.workOrderStatusColor = appointment.workorderStatusColor;
        mapData.appointmentDetails.workOrderStatusId = appointment.workorderStatusId;
        mapData.appointmentDetails.brand = appointment.companyMakeCode;
        mapData.appointmentDetails.chassisNo = appointment.chassisNo?.toString();
        mapData.appointmentDetails.createdDateTime = appointment.createdDateTime ? new Date(appointment.createdDateTime + 'Z') : null;
        mapData.appointmentDetails.dmsSyncDate = appointment.dmsSyncDate ? new Date(appointment.dmsSyncDate + 'Z') : null;
        
        if (!appointment.isFromArchive) {
            if (this.appointmentService.appointmentStatusList?.length > 0) {
                const editable = this.appointmentService.appointmentStatusList.find(x => x.id === appointment.workorderStatusId);
                if (editable?.isEditable) {
                    if (appointment.appointmentType === Enums.AppointmentType.OFFER && appointment.isQuoteExipred) {
                        mapData.isEdit = false;
                    }
                    else {
                        mapData.isEdit = true;
                    }
                }
                const deletable = this.appointmentService.appointmentStatusList.find(x => x.id === appointment.workorderStatusId);
                if (deletable?.isDeletable) {
                    mapData.isDelete = true;
                }
            }
        }

        if (isCommingFromWar) {
            if (this.appointmentService.appointmentStatusList?.length > 0) {
                const editable = this.appointmentService.appointmentStatusList.find(x => x.id === appointment.workorderStatusId);
                if (editable?.isEditable) {
                    mapData.isEdit = false;
                }
                const deletable = this.appointmentService.appointmentStatusList.find(x => x.id === appointment.workorderStatusId);
                if (deletable?.isDeletable) {
                    mapData.isDelete = true;
                }
            }
        }
        return mapData;
    }
    private ApplyEditPopupClass(isOpen: boolean) {
        const leftMenucontent = document.getElementsByClassName('content')[0];
        if (leftMenucontent) {
            leftMenucontent.classList.remove(isOpen ? "sidebar-open" : "sidebar-close");
            leftMenucontent.classList.add(isOpen ? "sidebar-close" : "sidebar-open");
        }
        const leftMenuIcon = document.getElementsByClassName('fas')[0];
        if (leftMenuIcon) {
            leftMenuIcon.classList.remove(isOpen ? "fa-bars" : "fa-arrow-right");
            leftMenuIcon.classList.add(isOpen ? "fa-arrow-right" : "fa-bars");
        }
    }
    private async GetAllAppointmentStatusList() {
        if (!this.appointmentService.appointmentStatusList?.length) {
            if (this.secureStorage.getKeyData("AppointmentStatusList")?.length > 0) {
                this.appointmentService.appointmentStatusList = this.secureStorage.getKeyData("AppointmentStatusList");
            }
            else {
                this.languageCode = this.cookieservice.get('userSelectedLanguage');
                await this.appointmentService.GetAppointmentStatusList(this.languageCode).then(data => {
                    if ( data?.woStatusList) {
                        this.appointmentService.appointmentStatusList = data.woStatusList;
                        this.secureStorage.setKeyData("AppointmentStatusList", this.appointmentService.appointmentStatusList);
                    }
                });
            }
        }
    }
    //#endregion
}
